import React, {useContext} from 'react'
import {Navigate, useLocation} from "react-router-dom"
import {Content} from "@carbon/react";
import authContext from "../Auth/AuthContext";

const SecRoute = ({children}) => {
  const authCtx = useContext(authContext)
  let location = useLocation();
  if (!authCtx.isLoggedIn) {
    return <Navigate to="/login" state={{from: location}} replace/>
  }
  return (
    <Content>
      {children}
    </Content>
  )
};

export default SecRoute;